// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Pervasives from "rescript/lib/es6/pervasives.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

var _map = {"page":"page"};

function ariaCurrentToJs(param) {
  return param;
}

function ariaCurrentFromJs(param) {
  return _map[param];
}

var _map$1 = {"off":"off","polite":"polite","assertive":"assertive"};

function ariaLiveToJs(param) {
  return param;
}

function ariaLiveFromJs(param) {
  return _map$1[param];
}

var _map$2 = {"menu":"menu","listbox":"listbox","tree":"tree","grid":"grid","dialog":"dialog"};

function ariaHasPopupToJs(param) {
  return param;
}

function ariaHasPopupFromJs(param) {
  return _map$2[param];
}

function PropSpread(props) {
  var target = props.target;
  var data = props.data;
  var aria = props.aria;
  var aria$1 = aria !== undefined ? aria : /* [] */0;
  var data$1 = data !== undefined ? data : /* [] */0;
  var spreadProps = Js_dict.fromList(Belt_List.concat(Belt_List.map(aria$1, (function (aria) {
                  switch (aria.TAG | 0) {
                    case /* Current */0 :
                        return [
                                "aria-current",
                                aria._0
                              ];
                    case /* HasPopup */1 :
                        return [
                                "aria-haspopup",
                                aria._0
                              ];
                    case /* Hidden */2 :
                        return [
                                "aria-hidden",
                                Pervasives.string_of_bool(aria._0)
                              ];
                    case /* Label */3 :
                        return [
                                "aria-label",
                                aria._0
                              ];
                    case /* LabelledBy */4 :
                        return [
                                "aria-labelledby",
                                aria._0
                              ];
                    case /* Live */5 :
                        return [
                                "aria-live",
                                aria._0
                              ];
                    case /* Controls */6 :
                        return [
                                "aria-controls",
                                aria._0
                              ];
                    case /* Expanded */7 :
                        return [
                                "aria-expanded",
                                Pervasives.string_of_bool(aria._0)
                              ];
                    
                  }
                })), Belt_List.map(data$1, (function (data) {
                  if (data.TAG === /* Cy */0) {
                    return [
                            "data-cy",
                            data._0
                          ];
                  } else {
                    return [
                            "data-testid",
                            data._0
                          ];
                  }
                }))));
  var tabIndex = Belt_Option.map(props.tabIndex, (function (prim) {
          return String(prim);
        }));
  if (tabIndex !== undefined) {
    spreadProps["tabIndex"] = tabIndex;
  }
  if (target !== undefined) {
    spreadProps["target"] = target;
  }
  return React.cloneElement(props.children, spreadProps);
}

var make = PropSpread;

export {
  ariaCurrentToJs ,
  ariaCurrentFromJs ,
  ariaLiveToJs ,
  ariaLiveFromJs ,
  ariaHasPopupToJs ,
  ariaHasPopupFromJs ,
  make ,
}
/* react Not a pure module */
